class AlgoliaRecommendations extends window.StimulusController {
  static values = {
    widget: String,
    max: Number,
    threshold: Number,
    slidesSmall: Number,
    slidesMedium: Number,
    slidesLarge: Number,
    productId: String,
  };

  static targets = [
    "container",
    "swiper",
    "wrapper",
    "pagination",
    "nextBtn",
    "prevBtn",
  ];

  connect() {
    this.initializeObserver();
  }

  disconnect() {
    this.observer?.disconnect();
  }

  // Initializes the IntersectionObserver to load recommendations when the element enters the viewport
  initializeObserver() {
    // remove any previous observer
    this.observer?.unobserve(this.element);

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        // stops observing when it enters the viewport
        observer.unobserve(this.element);

        this.initAlgolia();
      },
      {
        // preload already 400px before the element enters the viewport
        rootMargin: "0px 0px 400px 0px",
      },
    );

    this.observer.observe(this.element);
  }

  initAlgolia() {
    const instantsearch = window.instantsearch;
    const { frequentlyBoughtTogether, relatedProducts, trendingItems } =
      instantsearch.widgets;
    const { liteClient: algoliasearch } = window["algoliasearch/lite"];
    const searchClient = algoliasearch(
      "8XX4VN73F4",
      "7308589441aeff6808ba688a19d7c5eb",
    );

    const widgetMap = {
      frequentlyBoughtTogether,
      relatedProducts,
      trendingItems,
    };

    const search = instantsearch({
      searchClient,
      indexName: "shopify_prod_products_italy_ia",
    }).addWidgets([
      widgetMap[this.widgetValue]({
        container: this.containerTarget,
        objectIDs: [this.productIdValue],
        limit: this.maxValue,
        threshold: this.thresholdValue,
        templates: {
          header() {
            return "";
          },
          layout: ({ items }) => this.renderProducts(items),
        },
      }),
    ]);

    search.start();
  }

  renderProducts(items) {
    const fetches = items.map((recommendation, index) =>
      fetch(
        `/products/${recommendation.handle}?section_id=render-recommendation`,
      )
        .then((r) => r.text())
        .then((html) => {
          const start = html.indexOf(">") + 1;
          const end = html.lastIndexOf("</div>");
          const innerHTML = html.substring(start, end);
          if (innerHTML.trim() !== "") {
            return `<div class="swiper-slide tw-max-w-56 tw-h-auto" data-index="${index}">${innerHTML}</div>`;
          }
          return "";
        }),
    );

    Promise.all(fetches).then((slides) => {
      this.wrapperTarget.innerHTML = slides.join("");
      this.initSwiper();
    });
    return "";
  }

  initSwiper() {
    new Swiper(this.swiperTarget, {
      spaceBetween: 10,
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: this.nextBtnTarget,
        prevEl: this.prevBtnTarget,
      },
      pagination: {
        el: this.paginationTarget,
        bulletClass:
          "swiper-pagination-bullet tw-border tw-border-blue-700 tw-bg-transparent tw-opacity-100",
        bulletActiveClass: "!tw-bg-blue-700",
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: this.slidesSmallValue },
        640: { slidesPerView: this.slidesMediumValue },
        1024: { slidesPerView: this.slidesLargeValue },
        1280: { slidesPerView: this.slidesLargeValue },
      },
    });
  }
}

Stimulus.register("algoliaRecommendations", AlgoliaRecommendations);
